import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { environment } from "@environment";
import { ConfigService } from "../../config.service";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { JurisdictionalAgency } from "../../../_models";
import { IrwinIncident } from "../../../_models/incident/irwin/irwinIncident";
import { WfdssCase } from "../../../_models/incident/wfdssCase/wfdssCase";
// import { CollaboratorService } from "../../user/collaborator.service";

/**
 * Service to manually push Irwin attributes to Irwin from support dashboard.
 */
@Injectable({
  providedIn: "root",
})
export class IrwinAttributeUpdaterService {
  private readonly baseUrl = this.environment.irwinApi.baseUrl;

  private readonly updateAttributeUrl =
    this.baseUrl + this.environment.irwinApi.updateAttribute;

  private readonly updateAttributesUrl =
    this.baseUrl + this.environment.irwinApi.updateAttributes;

  constructor(private http: HttpClient, private environment: ConfigService) {}

  pushIrwinAttribute(irwinId, irwinAttribute, irwinAttributeValue) {
    return this.http.get<any>(this.updateAttributeUrl, {
      params: { irwinId, irwinAttribute, irwinAttributeValue },
    });
  }

  pushIrwinAttributes(irwinId, irwinAttributes) {
    return this.http.post<any>(this.updateAttributesUrl, irwinAttributes, {
      params: { irwinId },
    });
  }
}
